/*
Copyright 2025 Adobe. All rights reserved.
This file is licensed to you under the Apache License, Version 2.0 (the "License");
you may not use this file except in compliance with the License. You may obtain a copy
of the License at http://www.apache.org/licenses/LICENSE-2.0

Unless required by applicable law or agreed to in writing, software distributed under
the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
OF ANY KIND, either express or implied. See the License for the specific language
governing permissions and limitations under the License.
*/

import { tag as html, TemplateResult } from '../custom-tag.js';

export { setCustomTemplateLiteralTag } from '../custom-tag.js';
export const HotFixesIcon = ({
  width = 24,
  height = 24,
  hidden = false,
  title = 'Hot Fixes',
} = {}): string | TemplateResult => {
  return html`<svg
    xmlns="http://www.w3.org/2000/svg"
    width="${width}"
    height="${height}"
    viewBox="0 0 36 36"
    aria-hidden=${hidden ? 'true' : 'false'}
    role="img"
    fill="currentColor"
    aria-label="${title}"
  >
    <path
      d="M14.14 1.787a.5.5 0 0 0-.852.471 15.054 15.054 0 0 1 .653 6.566 16.977 16.977 0 0 1-2.91 6.165 26.831 26.831 0 0 0-2.849 5.5 10.411 10.411 0 1 0 20.223 3.5v-.037c-.076-4.845-3.036-11.542-6.022-16a.5.5 0 0 0-.907.327c.521 8.357-4 11.315-4 11.315S21.124 9.256 14.14 1.787Z"
    />
  </svg>`;
};
